import React from 'react'

export const AddReview = () => {
    return (
        <>
            {/* <!-- Add Review Box --> */}
            <div id="add-review" className="add-review-box">

                {/* <!-- Add Review --> */}
                <h3 className="listing-desc-headline margin-bottom-10">Add Review</h3>
                <p className="comment-notes">Your email address will not be published.</p>

                {/* <!-- Subratings Container --> */}
                <div className="sub-ratings-container">

                    {/* <!-- Subrating #1 --> */}
                    <div className="add-sub-rating">
                        <div className="sub-rating-title">Service <i className="tip" data-tip-content="Quality of customer service and attitude to work with you"></i></div>
                        <div className="sub-rating-stars">
                            {/* <!-- Leave Rating --> */}
                            <div className="clearfix"></div>
                            <form className="leave-rating">
                                <input type="radio" name="rating" id="rating-1" value="1" />
                                <label for="rating-1" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-2" value="2" />
                                <label for="rating-2" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-3" value="3" />
                                <label for="rating-3" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-4" value="4" />
                                <label for="rating-4" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-5" value="5" />
                                <label for="rating-5" className="fa fa-star"></label>
                            </form>
                        </div>
                    </div>

                    {/* <!-- Subrating #2 --> */}
                    <div className="add-sub-rating">
                        <div className="sub-rating-title">Value for Money <i className="tip" data-tip-content="Overall experience received for the amount spent"></i></div>
                        <div className="sub-rating-stars">
                            {/* <!-- Leave Rating --> */}
                            <div className="clearfix"></div>
                            <form className="leave-rating">
                                <input type="radio" name="rating" id="rating-11" value="1" />
                                <label for="rating-11" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-12" value="2" />
                                <label for="rating-12" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-13" value="3" />
                                <label for="rating-13" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-14" value="4" />
                                <label for="rating-14" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-15" value="5" />
                                <label for="rating-15" className="fa fa-star"></label>
                            </form>
                        </div>
                    </div>

                    {/* <!-- Subrating #3 --> */}
                    <div className="add-sub-rating">
                        <div className="sub-rating-title">Location <i className="tip" data-tip-content="Visibility, commute or nearby parking spots"></i></div>
                        <div className="sub-rating-stars">
                            {/* <!-- Leave Rating --> */}
                            <div className="clearfix"></div>
                            <form className="leave-rating">
                                <input type="radio" name="rating" id="rating-21" value="1" />
                                <label for="rating-21" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-22" value="2" />
                                <label for="rating-22" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-23" value="3" />
                                <label for="rating-23" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-24" value="4" />
                                <label for="rating-24" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-25" value="5" />
                                <label for="rating-25" className="fa fa-star"></label>
                            </form>
                        </div>
                    </div>

                    {/* <!-- Subrating #4 --> */}
                    <div className="add-sub-rating">
                        <div className="sub-rating-title">Cleanliness <i className="tip" data-tip-content="The physical condition of the business"></i></div>
                        <div className="sub-rating-stars">
                            {/* <!-- Leave Rating --> */}
                            <div className="clearfix"></div>
                            <form className="leave-rating">
                                <input type="radio" name="rating" id="rating-31" value="1" />
                                <label for="rating-31" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-32" value="2" />
                                <label for="rating-32" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-33" value="3" />
                                <label for="rating-33" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-34" value="4" />
                                <label for="rating-34" className="fa fa-star"></label>
                                <input type="radio" name="rating" id="rating-35" value="5" />
                                <label for="rating-35" className="fa fa-star"></label>
                            </form>
                        </div>
                    </div>

                    {/* <!-- Uplaod Photos --> */}
                    <div className="uploadButton margin-top-15">
                        <input className="uploadButton-input" type="file" name="attachments[]" accept="image/*, application/pdf" id="upload" multiple />
                        <label className="uploadButton-button ripple-effect" for="upload">Add Photos</label>
                        <span className="uploadButton-file-name"></span>
                    </div>
                    {/* <!-- Uplaod Photos / End --> */}

                </div>
                {/* <!-- Subratings Container / End -->

<!-- Review Comment --> */}
                <form id="add-comment" className="add-comment">
                    <fieldset>

                        <div className="row">
                            <div className="col-md-6">
                                <label>Name:</label>
                                <input type="text" value="" />
                            </div>

                            <div className="col-md-6">
                                <label>Email:</label>
                                <input type="text" value="" />
                            </div>
                        </div>

                        <div>
                            <label>Review:</label>
                            <textarea cols="40" rows="3"></textarea>
                        </div>

                    </fieldset>

                    <button className="button">Submit Review</button>
                    <div className="clearfix"></div>
                </form>

            </div>
            {/* <!-- Add Review Box / End --> */}
        </>
    )
}